export default "__VITE_ASSET__43adfd5c__"